import script from "./OpenTableWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenTableWidget.vue?vue&type=script&setup=true&lang=js"

import "./OpenTableWidget.vue?vue&type=style&index=0&id=150e59f2&lang=scss"

const __exports__ = script;

export default __exports__